import BaseModel from '../core/BaseModel'
export default class CountryModel extends BaseModel {

    constructor() {
        super({
                name: "country",
                tableName: 'country',
                label: "country",
            display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Name'
                },
                detail_get: {
                    refs:  'time_zone is_display_phone_admin phone_code',
                    display: false
                },
            })
    }

}